const PayIcon = (
  <svg
    className="fill-current"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <circle cx="5.5" cy="15.5" r="1.5" />

    <path d="M19 3H5C2.23858 3 0 5.23858 0 8V16C0 18.7614 2.23858 21 5 21H19C21.7614 21 24 18.7614 24 16V8C24 5.23858 21.7614 3 19 3ZM5 5H19C20.6569 5 22 6.34315 22 8H2C2 6.34315 3.34315 5 5 5ZM19 19H5C3.34315 19 2 17.6569 2 16V10H22V16C22 17.6569 20.6569 19 19 19Z" />
  </svg>
);

export default PayIcon;